module.exports = __webpack_public_path__ + "static/media/brThumbnail13.bea24941.jpg";